module.exports = __webpack_public_path__ + "img/f79021f.jpg";